import { useIsCheckin, useIsPostBooking, useManageBooking } from "@repo/store/slices";

export const useExtrasStatus = () => {
  const bookingData = useManageBooking();
  const isCheckIn = useIsCheckin();
  const isPostBooking = useIsPostBooking();

  const outBoundJourney = bookingData?.journeys?.[0];
  const inBoundJourney =
    (bookingData?.journeys?.length ?? 0) > 1 ? bookingData?.journeys?.[1] : null;

  const isOutboundSegmentClosed = Boolean(
    outBoundJourney?.checkInStatus?.isDisabled || outBoundJourney?.checkInStatus?.isClosed,
  );

  const isOutboundClose = Boolean(
    (isCheckIn || isPostBooking) &&
    (outBoundJourney?.checkInStatus?.isTooLate ||
      outBoundJourney?.checkInStatus?.isImminent ||
      outBoundJourney?.checkInStatus?.isClosed),
  );

  const isInboundSegmentClosed = Boolean(
    inBoundJourney?.checkInStatus?.isDisabled || inBoundJourney?.checkInStatus?.isClosed,
  );

  const isInboundClose = Boolean(
    (isCheckIn || isPostBooking) &&
    (inBoundJourney?.checkInStatus?.isTooLate ||
      inBoundJourney?.checkInStatus?.isImminent ||
      inBoundJourney?.checkInStatus?.isClosed),
  );

  return {
    isOutboundClose,
    isInboundClose,
    isOutboundSegmentClosed,
    isInboundSegmentClosed,
  };
};
